import { defineComponent, computed } from 'vue';
import { generateColor } from '../util';
function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
}
export default defineComponent({
    name: 'AColorSaturation',
    props: {
        prefixCls: String,
        value: { type: Object, required: true },
    },
    emits: ['change', 'changeComplete'],
    setup(props, { emit }) {
        const hueColor = computed(() => {
            const { h } = props.value.toHsb();
            return `hsl(${h}, 100%, 50%)`;
        });
        const pointerStyle = computed(() => {
            const { s, b } = props.value.toHsb();
            return {
                left: `${s * 100}%`,
                top: `${(1 - b) * 100}%`,
            };
        });
        const updateFromEvent = (e, complete) => {
            var _a, _b, _c, _d;
            const target = (e.currentTarget || e.target);
            const rect = target.getBoundingClientRect();
            const clientX = 'touches' in e ? (_b = (_a = e.touches[0]) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : 0 : e.clientX;
            const clientY = 'touches' in e ? (_d = (_c = e.touches[0]) === null || _c === void 0 ? void 0 : _c.clientY) !== null && _d !== void 0 ? _d : 0 : e.clientY;
            const x = clamp((clientX - rect.left) / rect.width, 0, 1);
            const y = clamp((clientY - rect.top) / rect.height, 0, 1);
            const { h, a } = props.value.toHsb();
            const next = generateColor({ h, s: x, b: 1 - y, a });
            emit('change', next);
            if (complete)
                emit('changeComplete', next);
        };
        const onMouseDown = (e) => {
            e.preventDefault();
            updateFromEvent(e);
            const onMove = (ev) => updateFromEvent(ev);
            const onUp = (ev) => {
                updateFromEvent(ev, true);
                window.removeEventListener('mousemove', onMove);
                window.removeEventListener('mouseup', onUp);
            };
            window.addEventListener('mousemove', onMove);
            window.addEventListener('mouseup', onUp);
        };
        return () => (<div class={`${props.prefixCls}-saturation`} style={{ backgroundColor: hueColor.value }} onMousedown={onMouseDown}>
        <div class={`${props.prefixCls}-saturation-handler`} style={pointerStyle.value}/>
      </div>);
    },
});
